import { Component, OnInit, Input } from '@angular/core';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css']
})
export class OrderStatusComponent implements OnInit {

  @Input() orderStatus: OrderStatusObject;

  constructor() { }

  ngOnInit() {
  }

}
